import { render } from "./CalendarView.vue?vue&type=template&id=20b733d2&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=20b733d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b733d2"],['__file',"src/views/h5/crm/kpi/CalendarView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20b733d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20b733d2', __exports__)) {
    api.reload('20b733d2', __exports__)
  }
  
  module.hot.accept("./CalendarView.vue?vue&type=template&id=20b733d2&scoped=true", () => {
    api.rerender('20b733d2', render)
  })

}


export default __exports__